import React, { useEffect, useState } from "react";

import ProDropDown from "../common/ProDropDown";
import ProInputText from "../common/ProInputText";
import ProInputNumber from "../common/ProInputNumber";
import ProCheckBox from "../common/ProCheckbox";
import ProAutoComplete from "../common/ProAutoComplete";
import ProFormFooter from "../common/ProFormFooter";
import ProAddress from "../common/ProAddress";
import ProTextArea from "../common/ProTextArea";
import ProCustomAutoComplete from "../common/ProCustomAutoComplete";
import {selectedLevelType, levelOptionType } from "../common/ProTreeNodeLevelType"

import { useFormik } from "formik";
import useSetup from "../../hooks/useSetup";
import useSetupForm from "../../hooks/useSetupForm";
import useFormServices from "../../hooks/useFormServices";
import useRolePermissionServices from "../../hooks/useRolePermissionServices";


import {useLocationServices} from "../../hooks/useLocationServices";
import {useBedServices} from "../../hooks/useBedServices";
import {useStaffService} from "../../hooks/useStaffService";
import { useHierarchyService } from "../../hooks/useHierarchyService";
import { useDialogService } from "../../hooks/useDialogService";

import RootValidator from "./validators/RootValidator";
import { GetNode, ExceedsBedLimit, Severity } from "../../constants/ProConstants";
import {capitalizeFirstLetter} from '../../utilities/Helper'
import _ from "lodash";
import "primeflex/primeflex.css";


const ProSetupForm = ({
    showFooter = false,
    closeSideBar = () => console.log("close"), formModel={}, formAction
}) => { 
    const {data:{SetupRoles}} = useRolePermissionServices(); 
    const {actions:{ShowDialog}} = useDialogService();
    const { data:{selectedLocations}, actions:{AddNode, EditNode}} = useSetup({refreshTree:false});
    const {data :{activeTree, selectedTreeNode, filteredLevelTypes, selectedType, buildings, parents, parentTypes, rooms}, actions:{OnTypeChanged}} = useHierarchyService();  
    const {states, programs} = useLocationServices();
    const {bedStatuses, bedTypes, tagService} = useBedServices(); 
    const [filteredTags, SearchTag] = tagService;
    const {actions:{Initialize, ConfirmFormAction, UpdateFormState}} = useFormServices()
    const [isMounted, setIsMounted] = useState(false)

    const formik = useFormik({
        initialValues: {
            type: _.isEmpty(formModel)? {}: formModel.type,
            model: _.isEmpty(formModel)? {}: formModel.model,
        },
        validate: (data) => {
            if(!_.isEqual(formAction, "CANCEL"))
                return RootValidator(data, activeTree);
        },
        onSubmit: (data) => {           
            handleSubmit(data);
            formik.resetForm();
        },
    });
    
    const { onChanged } = useSetupForm({formik, formModel});
    const {filteredStaff, SearchStaff} = useStaffService(formik);

    const isTypeSelected = () => {
        return _.includes(_.valuesIn(selectedType), true)        
    }; 

    const canActivate = ()=>{
        if(isTypeSelected() && _.get(formik.values.model, 'building')){
            if(!_.isNull(formik.values.model.building)){
                if(_.get(formik.values.type, "code") !== 'BED')
                    return _.isEmpty(formik.values.model.parent)? formik.values.model.building.active : formik.values.model.parent.active
                else if(!_.isNull(formik.values.model.room))
                    return formik.values.model.room.active
            }
        }
        return true;
    }
  
 
    const handleSubmit = async (data) => {       
        if (!_.isEmpty(data)) { 
            closeSideBar(); 
            OnTypeChanged(null);   
            formik.resetForm();        
            switch(formAction){  
                case "ADD":  
                    if(data.type.code === "BED" && ExceedsBedLimit(activeTree, data.model)){ 
                        await ShowDialog("Add Bed and Exceed Capacity?", "Adding this bed exceeds the bed capacity defined at a parent level.  Are you sure you wish to proceed?", null, "Yes, Add Bed", "Cancel", Severity.Danger,
                        async ()=>{
                           await AddNode(GetNode(data), data);
                        },
                        ()=>{
                            console.log("Add not confirmed"); 
                        })
                        break; 
                    }
                    else                 
                        await AddNode(GetNode(data), data); 
                    break;
                case "EDIT":     
                    if(data.type.key !== 'BED' && formModel && formModel.model.isActive ===  false && data.model.isActive) { 
                        var header =  `Activate ${capitalizeFirstLetter(selectedTreeNode.type)} ${selectedTreeNode.label}`                     
                        var body =   "This action activates any dependent levels and beds.\n Are you sure you want to proceed?"
                        var labelOk = `Yes, Activate ${capitalizeFirstLetter(selectedTreeNode.type)}`;
                        var labelCancel = "Cancel"                       
                        await ShowDialog(header, body, null, labelOk, labelCancel, Severity.Danger, 
                        async ()=>{
                            data.model['reactivateChildren'] = true;
                            await EditNode(GetNode(data), data);  
                         },                         
                        async ()=>{
                            await EditNode(GetNode(data), data); 
                        })
                    } else {
                        await EditNode(GetNode(data), data); 
                    }            
                       
                    break;
                default:
                    break;
            }           
        }             
    };   
    
    const GetHeaderByType = ()=>{
      
        return selectedType.isFloor?"Floor Details" : 
        selectedType.isWing?"Wing Details":
        selectedType.isUnit?"Unit Details": 
        selectedType.isRoom? "Room Details" :
        selectedType.isBuilding?"Building Details":
        selectedType.isBed?"Bed Details" : ""
    }

    useEffect(()=>{         
        if(!isMounted){
            setIsMounted(true);           
            Initialize(closeSideBar)
        }
        if(isMounted){            
            ConfirmFormAction();            
        }      
            
    }, [selectedTreeNode])

    useEffect(()=>{
        return ()=>{  
            UpdateFormState(false)                   
        }
    }, [])

    return (
        <form onSubmit={formik.handleSubmit}>
            <ProDropDown
                headerText="Type"
                id="type"
                value={formik.values.type}
                style={{ width: "100%", marginBottom: "2px", height: "40px" }}
                onChange={onChanged}
                options={filteredLevelTypes}
                valueTemplate={selectedLevelType}
                optionTemplate={levelOptionType}
                optionLabel="name"
                placeholder="Level Type"
                formik={formik}
                 error = "type"
                 required
            />           
            {isTypeSelected() && (
                    <ProDropDown
                        headerText="Building Assignment"
                        id="location"
                        value={formik.values.model.location}
                        style={{ width: "100%", marginBottom: "2px" }}
                        onChange={onChanged}
                        options={selectedLocations}
                        optionLabel="name"
                        placeholder="Location"
                        formik={formik}
                        error="location"
                        required
                    />  
            )}

            {(isTypeSelected() && !selectedType.isBuilding) && (               
                    <ProDropDown
                        id="building"
                        value={formik.values.model.building}
                        style={{ width: "100%", marginBottom: "2px" }}
                        onChange={onChanged}
                        options={buildings}
                        optionLabel="name"
                        placeholder="Building"
                        formik={formik}
                        error="building"   
                        required                     
                    />  
            )}
            
            {(isTypeSelected() && !selectedType.isBuilding  && !_.isEmpty(formik.values.model.building)) && (                
                    <ProDropDown
                        id="parentType"
                        value={formik.values.model.parentType}
                        style={{ width: "100%", marginBottom: "2px" }}
                        onChange={onChanged}
                        options={parentTypes}
                        optionLabel="name"
                        placeholder="Add To"
                        formik={formik}
                        error="parentType"
                        required
                    />   
            )}
            {(isTypeSelected() && _.has(formik.values.model, "parentType") && !_.isEqual(formik.values.model.parentType.code, "BUILDING")) //&& !selectedType.isBuilding && !_.isEmpty(formik.values.model.building) &&
            && (                
                    <ProDropDown
                        id="parent"
                        value={formik.values.model.parent}
                        style={{ width: "100%", marginBottom: "2px" }}
                        onChange={onChanged}
                        options={parents}
                        optionLabel="name"
                        placeholder={formik.values.model.parentType.name}
                        formik={formik}
                        error="parent"
                        required
                    />   
            )}   
            {(isTypeSelected() && selectedType.isBed) && (               
                <ProDropDown
                    id="room"
                    value={formik.values.model.room}
                    style={{ width: "100%", marginBottom: "2px" }}
                    onChange={onChanged}
                    options={rooms}
                    optionLabel="name"
                    placeholder="Room"
                    formik={formik}
                    error="room"
                    required
                /> 
            )}        
           
            {isTypeSelected() && (
                <div>
                    <ProInputText
                        headerText= {GetHeaderByType()}
                        id="name"
                        labelText="Name"
                        value={formik.values.model.name}
                        onChange={onChanged}
                        formik={formik}
                        error="name" 
                        required                       
                    />                                  
                    {!selectedType.isBed && <ProInputNumber
                        id="bedCapacity"
                        labelText="Bed Capacity"
                        value={formik.values.model.bedCapacity}
                        onChange={onChanged}
                        formik={formik}
                        error="bedCapacity"
                    />}
                   { !selectedType.isBed && <ProDropDown
                     id="program"
                     value={formik.values.model.program}
                     style={{ width: "100%", marginBottom: "2px" }}
                     onChange={onChanged}
                     options={programs}
                     optionLabel="name"
                     placeholder="Program"
                 />  }              
                </div>
            )} 
            {(isTypeSelected() && selectedType.isBed) &&(
                 <div>
                <ProDropDown
                     id="bedStatus"
                     value={formik.values.model.bedStatus}
                     style={{ width: "100%", marginBottom: "2px" }}
                     onChange={onChanged}
                     options={bedStatuses}
                     optionLabel="name"
                     placeholder="Status"
                     required
                 />
                 <ProDropDown
                     id="bedType"
                     value={formik.values.model.bedType}
                     style={{ width: "100%", marginBottom: "2px" }}
                     onChange={onChanged}
                     options={bedTypes}
                     optionLabel="name"
                     placeholder="Type"
                 /> 
                  <ProInputText                       
                        id="occupancyStatus"
                        labelText="Occupancy Status"
                        value={_.get(formik.values.model, "occupancyStatus")?formik.values.model.occupancyStatus.name : 'Unoccupied'}
                        onChange={onChanged}
                        disabled
                        required
                    />
                    <ProInputText                       
                        id="reservationStatus"
                        labelText="Reservation Status"
                        value={_.get(formik.values.model, "reservationStatus")?formik.values.model.reservationStatus.name : 'Available'}
                        onChange={onChanged}
                        disabled
                        required
                    />
                 <ProAutoComplete
                        id="bedTags"                    
                        labelText="Tags"
                        field = "name"
                        value={formik.values.model.bedTags}
                        suggestions = {filteredTags}
                        completeMethod = {SearchTag}                        
                        onChange={onChanged}
                    />               
             </div>

            )}
             {selectedType.isBuilding  && (
                <div>                   
                    <ProCheckBox
                        id="sameAsLocationAddress"
                        name="sameAsLocationAddress"
                        labelText="Same as Location Address"
                        checked={formik.values.model.sameAsLocationAddress}
                        onChange={onChanged}
                    />
                    <ProAddress
                        id="address"
                        value={formik.values.model.address}                      
                        formik={formik} states={states} error="address" disabled = {formik.values.model.sameAsLocationAddress}
                    />                   
                </div>
            )}           
            {isTypeSelected() && (
                <div>
                    <ProCheckBox
                        id= "isActive"
                        name="isActive"
                        labelText="Active"
                        checked={formik.values.model.isActive}                       
                        onChange={(e)=> { onChanged(e)}}
                        disabled={!canActivate()}
                    />
                    <ProCustomAutoComplete
                        id = "bedMngmtStaffDetails"
                        headerText="Staff"
                        labelText="Assigned Staff"
                        field = "fullName"
                        minLength = {3}
                        value={_.isEmpty(formik.values.model.bedMngmtStaffDetails)?null: formik.values.model.bedMngmtStaffDetails}
                        suggestions = {filteredStaff}
                        completeMethod = {SearchStaff}                        
                        onChange={onChanged}
                        disabled={!SetupRoles.canAssignStaff}
                    />
                    <ProTextArea
                        headerText="Notes"
                        id="note"
                        labelText="Notes"
                        value={formik.values.model.note}
                        onChange={onChanged}
                        showCounter
                    />
                </div>
            )}
            {showFooter && (<ProFormFooter onSave={() => console.log("Save")}  onCancel={()=>{closeSideBar(); OnTypeChanged(null)}} enableOnDirty={formik.dirty}/> )}
        </form>
    );
};

export default ProSetupForm;
